import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { formatDateTimeWithoutSec, formattedDate, getCurrentDateTime1 } from "../../../../Common/helper/helpar";

export const MSWManagementTertiaryVehiclesExport = ({ data,fromDate,toDate }) => {
  const currentDateTime = getCurrentDateTime1();
  const reportTitle = `MSW Management Vehicles On Road - Tertiary Collection Report as on (${formattedDate(fromDate)} to ${formattedDate(toDate)})`;
  const topHeaderText = `MSW Management Vehicles On Road - Tertiary Collection Report is generated on (${currentDateTime})`;

  /* ================= TOTAL CALCULATION ================= */
  const totalRow = {
    plannedVehicles: data?.reduce(
      (a, b) => a + Number(b.plannedVehicles || 0),
      0
    ),

    deployedVehicles: data?.reduce(
      (a, b) => a + Number(b.deployedVehicles || 0),
      0
    ),

    performanceAchieved: data?.length
      ? (
          data.reduce(
            (a, b) => a + Number(b.performanceAchieved || 0),
            0
          ) / data.length
        ).toFixed(2)
      : 0,
  };

  /* ================= FINAL DATA ================= */
  const finalData = [...(data || []), { ...totalRow, isTotal: true }];

  /* ======================= EXCEL DOWNLOAD ======================= */
  const downloadAsExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Tertiary Vehicles");

    const bold = { bold: true };
    /* ---------- REPORT GENERATED ON ---------- */
    worksheet.addRow([topHeaderText]);
    worksheet.mergeCells("A1:E1");
    worksheet.getCell("A1").alignment = { horizontal: "center" };

    worksheet.addRow([reportTitle]);
    worksheet.mergeCells("A2:E2");
    worksheet.getCell("A2").font = bold;
    worksheet.getCell("A2").alignment = { horizontal: "center" };

    worksheet.addRow([]);

    /* ---------- HEADER ---------- */
    const headerRow = worksheet.addRow([
      "S.No",
      "Date",
      "Total Number of Vehicles Planned For Deployment",
      "Total Number of Vehicles Deployed",
      "Performance Achieved",
    ]);

    headerRow.eachCell((cell) => {
      cell.font = bold;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "F6B1B1" },
      };
      cell.alignment = { horizontal: "center" };
    });

    /* ---------- DATA ---------- */
    finalData.forEach((item, index) => {
      const isTotal = item.isTotal;

      worksheet
        .addRow([
          isTotal ? "" : index + 1,
          isTotal ? "Total" : formattedDate(item.date),
          item.plannedVehicles,
          item.deployedVehicles || 0,
           isTotal ? "" : item.performanceAchieved,
        ])
        .eachCell((cell) => {
          if (isTotal) cell.font = bold;
        });
    });

    /* ---------- CENTER ALIGN ---------- */
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber > 3) {
        row.eachCell((cell, colNumber) => {
          if (colNumber !== 2) {
            cell.alignment = { horizontal: "center" };
          } else {
            cell.alignment = { horizontal: "left" };
          }
        });
      }
    });

    worksheet.columns = [
      { width: 10 },
      { width: 18 },
      { width: 22 },
      { width: 22 },
      { width: 25 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "MSW_Tertiary_Vehicles.xlsx";
    link.click();
  };

  /* ======================= PDF DOWNLOAD ======================= */
  const downloadAsPDF = () => {
    const doc = new jsPDF("l", "mm", "a4");
    const styledText = (text, x, y, size, options = {}) => {
        const originalSize = doc.getFontSize();
        doc.setFontSize(size);
        doc.text(text, x, y, options);
        doc.setFontSize(originalSize); // Reverts back automatically
    };

    doc.setFontSize(10);
    // doc.text(getReportGeneratedOn(), 148, 22, { align: "center" });

    const tableColumn = [
      "S.No",
      "Date",
      "Total Number of Vehicles Planned For Deployment",
      "Total Number of Vehicles Deployed",
      "Performance Achieved",
    ];

    let serial = 1;
    const pageWidth = doc.internal.pageSize.width;
    const titleX = pageWidth / 2;
    styledText(topHeaderText, titleX, 15, 12, { align: "center" });
    styledText(reportTitle, titleX, 24, 14, { align: "center" });

    const tableRows = finalData.map((item) => {
      const isTotal = item.isTotal;

      return [
        isTotal ? "" : serial++,
        isTotal ? "Total" : formattedDate(item.date),
        item.plannedVehicles,
        item.deployedVehicles || 0,
         isTotal ? "" : item.performanceAchieved,
      ];
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 30,

      styles: {
        fontSize: 9,
        halign: "center",
      },

      didParseCell: function (data) {
        if (data.row.raw[1] === "Total") {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    doc.save("MSW_Tertiary_Vehicles.pdf");
  };

  /* ======================= UI ======================= */
  return (
    <>
      <button className="btn btn-excel me-2" onClick={downloadAsPDF}>
        <i className="fa-solid fa-file-pdf me-1"></i> PDF
      </button>

      <button className="btn btn-excel" onClick={downloadAsExcel}>
        <i className="fa-solid fa-file-excel me-1"></i> Excel
      </button>
    </>
  );
};
